import type { ItemStatus } from '../../domain/inspection';
import type { IconName } from '../../ui/icons';

// The one-row result selector (Figma 06–09 「标记评估状态」): a 2×2 grid of state tiles, each with its
// own glyph; the chosen one carries its result tone. Shared by the item sheet and — since 2026-09-14
// (Owner device test: "上面 AI 建议，建议下面就是如何完成这项检查") — by the AI suggestion sheet, so the
// inspector completes the row where the AI observation is, never in a separate place.
export const RESULT_OPTIONS: ReadonlyArray<{ status: ItemStatus; tone: 'pass' | 'defect' | 'unable' | 'na'; icon: IconName }> = Object.freeze([
  { status: 'checkedOk', tone: 'pass', icon: 'check_circle' },
  { status: 'issueFound', tone: 'defect', icon: 'warning' },
  { status: 'unableToInspect', tone: 'unable', icon: 'visibility_off' },
  { status: 'notApplicable', tone: 'na', icon: 'do_not_disturb_on' }
]);
